import React from 'react'
import styled from '@emotion/styled'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import { removeAcentos } from '../../Utils/stringUtils'

const ContactInfoContainer = styled('div')(({ theme }) => ({
  fontSize: '.75em',
  width: '100%',
  color: theme.palette.primary.main,
  padding: '0 2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-evenly',
  },
}))

const InputStyle = styled(TextField)(({ theme }) => ({
  width: '100%',
  marginTop: '15px',
  '& div': {
    height: '40px',
  },
  [theme.breakpoints.down('sm')]: {
    width: '48%',
  },
  [theme.breakpoints.only('xs')]: {
    width: '100%',
  },
}))

const TextAreaStyle = styled(TextField)({
  width: '100%',
  marginTop: '15px',
})

const HeaderContainer = styled('div')(({ theme, thirdParty }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: thirdParty ? 'center' : 'space-between',
  alignItems: 'center',
  flexDirection: thirdParty ? 'column' : 'row',
  marginBottom: '1rem',
}))

const ContactFormContainer = styled(Grid)(({ theme, thirdParty }) => ({
  fontSize: '.75em',
  width: '100%',
  padding: thirdParty ? '1rem' : '0',
  color: theme.palette.primary.main,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  [theme.breakpoints.only('sm')]: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
  },
  [theme.breakpoints.down('sm')]: {
    marginTop: '0.5rem',
  },
}))

function ContactInfo(props) {
  const { thirdParty = false } = props
  const { values, handleChange, errors, setFieldValue } = props.formikProps

  const removeAccentsOnBlur = (e) => {
    const { id, value } = e.target
    setFieldValue(id, removeAcentos(value || ''))
  }

  return (
    <ContactInfoContainer>
      <HeaderContainer thirdParty={thirdParty}>
        <h2>CONTACT INFORMATION</h2>
        {/* {isBOE && (
          <Button
            variant="contained"
            color="secondary"
            style={{ marginTop: '5px', fontSize: '10px' }}
            size="medium"
            onClick={() => {
              setFieldValue('contactPhone', values.operatorPhone)
              setFieldValue('contactEmail', values.operatorEmail)
            }}
          >
            Copy from Operator
          </Button>
        )} */}
      </HeaderContainer>
      <ContactFormContainer thirdParty={thirdParty}>
        <InputStyle
          id="contactName"
          name="contactName"
          label="FIRST NAME *"
          focused
          onChange={handleChange}
          onBlur={removeAccentsOnBlur}
          value={values.contactName}
          error={!!errors.contactName}
          helperText={errors?.contactName && errors?.contactName}
          size="small"
        />
        <InputStyle
          id="contactLastName"
          name="contactLastName"
          label="LAST NAME *"
          focused
          onChange={handleChange}
          onBlur={removeAccentsOnBlur}
          value={values.contactLastName}
          error={!!errors.contactLastName}
          helperText={errors?.contactLastName && errors?.contactLastName}
        />
        <InputStyle
          id="contactPhone"
          name="contactPhone"
          label="PHONE *"
          focused
          onChange={handleChange}
          value={values.contactPhone}
          error={!!errors.contactPhone}
          helperText={errors?.contactPhone && errors?.contactPhone}
        />
        <InputStyle
          id="contactEmail"
          name="contactEmail"
          label="EMAIL *"
          focused
          onChange={handleChange}
          value={values.contactEmail}
          error={!!errors.contactEmail}
          helperText={errors?.contactEmail && errors?.contactEmail}
        />
        <TextAreaStyle
          id="additionalEmails"
          name="additionalEmails"
          label="Additional Emails"
          variant="outlined"
          multiline
          rows={3}
          focused
          onChange={handleChange}
          value={values.additionalEmails}
          error={!!errors.additionalEmails}
          helperText={
            errors?.additionalEmails
              ? errors?.additionalEmails
              : 'Up to X email addresses separated by a comma'
          }
        />
      </ContactFormContainer>
    </ContactInfoContainer>
  )
}

export default ContactInfo
